import { Injectable } from '@angular/core';
import { unlockAccountView } from '@com-delta-idp/mnx-login-ui';
import { BehaviorSubject } from 'rxjs';
import { UnlockYourAccountAdapterService } from '../../adapters/unlock-your-account-adapter/unlock-your-account-adapter/unlock-your-account-adapter.service';
import { LoginModalContent } from '../../models/aem';
import { LoginContentService } from '../../services/login-content.service';

@Injectable({
  providedIn: 'root'
})
export class UnlockYourAccountFacadeService {
  pageContent$ = new BehaviorSubject<unlockAccountView | undefined>(undefined);
  aemContent!: LoginModalContent;

  constructor(
    private loginContentService: LoginContentService,
    private unlockYourAccountAdapterService: UnlockYourAccountAdapterService
  ) {
    this.getUnlockYourAccountPageContent();
  }

  getUnlockYourAccountPageContent() {
    this.loginContentService.getAEMContent().subscribe((response) => {
      this.aemContent = response;
      this.pageContent$.next(
        this.unlockYourAccountAdapterService.getUnlockYourAccountScreenContent(
          this.aemContent
        )
      );
    });
  }
}
